import React from 'react';
import PropTypes from 'prop-types';
import cname from './style.module.scss';
import {PipetteBody} from './PipetteBody';
import {PipettePlunger} from './PipettePlunger';
import {
  PLUNGER_STATE,
  PLUNGER_TOOLTIP_TYPE,
} from '../MicroPipette.constants';

/**
 * PlungerTooltip:
 *  - Component that display the tooltip over the plunger
 */
export function PlungerTooltip(props) {
  const wrapperClassName = () => `${cname.plungerTooltip}`;

  const pipetteClassName = () => `${cname.pipetteBody}`;

  const plungerClassName = () => cname[`plunger_${props.plungerState}`];

  return (
    <div className={wrapperClassName()}>
      <TooltipWrap
        plungerState={props.plungerState}
        tooltipType={props.tooltipType}
      />
      <div className={cname.tooltip_box}>
        <PipettePlunger className={plungerClassName()} type={props.type} />
        <PipetteBody className={pipetteClassName()} type={props.type} />
      </div>
    </div>
  );
}

PlungerTooltip.propTypes = {
  /**
   * Type of Pipette
   */
  type: PipetteBody.propTypes.type,
  /**
   * State of the plunger
   */
  plungerState: PropTypes.oneOf([
    PLUNGER_STATE.MIXING,
    PLUNGER_STATE.RELEASE,
    PLUNGER_STATE.FIRST_STOP,
    PLUNGER_STATE.SECOND_STOP,
  ]),
  /**
   * Type of tooltip being displayed
   */
  tooltipType: PropTypes.oneOf([
    PLUNGER_TOOLTIP_TYPE.MIXER,
    PLUNGER_TOOLTIP_TYPE.STOPPER,
  ]),
};

PlungerTooltip.defaultProps = {
  type: PipetteBody.defaultProps.type,
  plungerState: PLUNGER_STATE.RELEASE,
  tooltipType: PLUNGER_TOOLTIP_TYPE.STOPPER,
};

function TooltipWrap(props) {
  const isMixerTooltip = () => props.tooltipType === PLUNGER_TOOLTIP_TYPE.MIXER;

  const getTooltipLabel = () => {
    switch (props.plungerState) {
      case PLUNGER_STATE.MIXING:
        return 'Mix';
      case PLUNGER_STATE.FIRST_STOP:
        return 'First stop';
      case PLUNGER_STATE.SECOND_STOP:
        return 'Second stop';
      case PLUNGER_STATE.RELEASE: {
        if (isMixerTooltip()) {
          return 'Mix';
        }
        break;
      }
      default:
        return 'Release';
    }
  };

  const x = props.tooltipType === PLUNGER_TOOLTIP_TYPE.MIXER ? 50 : 8;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      version='1.2'
      baseProfile='tiny-ps'
      className={cname.tooltip}
      viewBox='0 0 100 147'
      width='100'
      height='147'>
      {isMixerTooltip() ? (
        <path
          xmlns='http://www.w3.org/2000/svg'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M41 3.78926e-08C31.6112 2.91487e-08 24 7.61116 24 17L24 31.6802C9.70348 40.5325 0.214019 56.4214 0.313271 74.5002C0.542715 116.293 50.5506 146.002 50.5506 146.002C50.5506 146.002 100.234 116.655 99.9999 73.9535C99.9959 73.2269 99.9765 72.504 99.9419 71.785C99.9804 71.195 100 70.5998 100 70L100 17C100 7.61116 92.3888 8.57517e-08 83 7.70078e-08L41 3.78926e-08Z'
          fill='#00AEEF'
        />
      ) : (
        <path
          xmlns='http://www.w3.org/2000/svg'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17 1.58322e-08C7.61116 7.08834e-09 7.08788e-09 7.61116 1.58318e-08 17L6.51916e-08 70C6.64967e-08 71.4013 0.106756 72.7777 0.312579 74.1215C0.312337 74.2476 0.312562 74.3738 0.313256 74.5001C0.5427 116.293 50.5506 146.002 50.5506 146.002C50.5506 146.002 100.234 116.655 99.9999 73.9535C99.8965 55.1129 89.4059 38.7646 74 30.3347L74 17C74 7.61116 66.3888 6.18285e-08 57 5.30846e-08L17 1.58322e-08Z'
          fill='#FAAC48'
        />
      )}
      <path
        id='Layer'
        fill='#336589'
        d='M50.01 122.74C24.29 122.88 3.4 102.21 3.25 76.5C3.11 50.78 23.79 29.89 49.5 29.74C75.21 29.6 96.11 50.28 96.25 75.99C96.39 101.7 75.72 122.6 50.01 122.74Z'
      />
      <text y='20' x={x} className={cname.tooltip_text}>
        {getTooltipLabel()}
      </text>
    </svg>
  );
}

TooltipWrap.propTypes = {
  /**
   * Type of Pipette
   */
  type: PlungerTooltip.propTypes.type,
  /**
   * State of the plunger
   */
  plungerState: PlungerTooltip.propTypes.plungerState,
  /**
   * type of tooltip
   */
  tooltipType: PlungerTooltip.propTypes.tooltipType,
};

TooltipWrap.defaultProps = {
  className: '',
  plungerState: PLUNGER_STATE.RELEASE,
  tooltipType: PLUNGER_TOOLTIP_TYPE.STOPPER,
};
